const yesNoTrueFalse = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

export default yesNoTrueFalse;
